import index from './index.vue';
import { UpdateType } from './all.type';

export default index;
export {
    UpdateType
};